
import { $document } from './bom';
export interface IClassNameMap {
    [prop: string]: boolean;
}

export function classSet(...args: Array<IClassNameMap | string >): string {
    let names: string = '';
    const classNames = args[0];
    if (typeof classNames === 'object') {
        const nameMap: IClassNameMap = classNames as IClassNameMap;
        for (const name in nameMap) {
            if (nameMap.hasOwnProperty(name) && nameMap[name]) {
                names += name + ' ';
            }
        }
    } else {
        const nameList = args;
        for (let i = 0; i < nameList.length; i++) {
            if (nameList[i]) {
                names += nameList[i] + ' ';
            }
        }
    }

    return names.trim();
}

export function querySelector(selectors: string): Element | null {
    return $document.querySelector(selectors);
}

export const appendChild = (node: Element, selector: string) => {
    if (selector) {
        const parent = querySelector(selector);
        if (parent) {
            return parent.appendChild(node);
        }
        return null;
    } else {
        return $document.body.appendChild(node);
    }

};
